export default __webpack_public_path__ + "static/media/0x2e1ad108ff1d8c782fcbbb89aad783ac49586756.862ce0bc.webp";